module.exports = __webpack_public_path__ + "./imgs/public_relation_bg_img_a.jpg?b72360527888dca29d5c9b1df8c6cf34";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/public_relation_bg_img_a.jpg
// module id = 14
// module chunks = 9 20